import React from 'react';
import { Table, Alert, Card } from 'react-bootstrap';
import moment from 'moment';

// W-0600 — grid read-only do Relatório de Digitalizações.
// Modo resumo (detalhe=false): 1 linha por usuário (Nome | Qtde) + footer Total geral.
// Modo detalhe (detalhe=true): 1 linha por registro (Nome | Data | Título | Tipo).
const formatarData = (valor) => {
  if (!valor) return '';
  const m = moment(valor);
  return m.isValid() ? m.format('DD/MM/YYYY') : String(valor);
};

const TabelaResultado = ({ linhas, detalhe, meta }) => {
  if (!linhas || linhas.length === 0) {
    return (
      <Alert variant="info" className="mt-3">
        Nenhum resultado encontrado.
      </Alert>
    );
  }

  const totalLinhas = meta && meta.total_linhas != null ? meta.total_linhas : linhas.length;
  const totalUsuarios = meta && meta.total_usuarios != null ? meta.total_usuarios : 0;

  return (
    <Card className="shadow-sm mt-3">
      <Card.Header style={{ backgroundColor: '#0747a6', color: '#fff', fontWeight: 'bold' }}>
        Resultado | {linhas.length} linha(s)
      </Card.Header>
      <Card.Body className="p-0">
        <div style={{ overflowX: 'auto' }}>
          <Table striped bordered hover size="sm" className="mb-0">
            {detalhe ? (
              <thead className="thead-dark">
                <tr>
                  <th>Nome</th>
                  <th>Data</th>
                  <th>Título</th>
                  <th>Tipo</th>
                </tr>
              </thead>
            ) : (
              <thead className="thead-dark">
                <tr>
                  <th>Nome</th>
                  <th className="text-right">Qtde</th>
                </tr>
              </thead>
            )}
            <tbody>
              {detalhe
                ? linhas.map((item) => (
                    <tr key={`${item.usuario_codigo}-${item.data}-${item.titulo}-${item.tipo}`}>
                      <td>{item.nome}</td>
                      <td>{formatarData(item.data)}</td>
                      <td>{item.titulo}</td>
                      <td>{item.tipo}</td>
                    </tr>
                  ))
                : linhas.map((item) => (
                    <tr key={item.usuario_codigo}>
                      <td>{item.nome}</td>
                      <td className="text-right">{item.qtde}</td>
                    </tr>
                  ))}
            </tbody>
            {!detalhe && (
              <tfoot>
                <tr style={{ backgroundColor: '#1a3a6b', color: '#fff' }}>
                  <td>
                    <strong>Total geral</strong>
                  </td>
                  <td className="text-right">
                    <strong>
                      {totalLinhas} digitalizações de {totalUsuarios} usuários
                    </strong>
                  </td>
                </tr>
              </tfoot>
            )}
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default TabelaResultado;
